import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Params} from '@angular/router';
import {Search} from '../common/search';
import {Multilingua} from '../model/multilingua';
import {MultilinguaService} from '../service/multilingua.service';
import {MenuService} from '../service/menu.service';
import {Location} from '@angular/common';

@Component({
    selector: 'app-disclaimer',
    templateUrl: './disclaimer.component.html',
})
export class DisclaimerComponent implements OnInit {

    @Output() disclaimerAccepted: EventEmitter<any> = new EventEmitter();

    public lingua: string;
    public pageName: string;
    public oldDisclaimer = true;

    constructor(private titleService: Title,
                private multilingueService: MultilinguaService,
                private menuService: MenuService,
                private location: Location,
                public route: ActivatedRoute) {

        this.route.params.subscribe((param: Params) => {
                // console.log('loading the component');
                if (param.id === "aumento-capitale" ||
                    param.id === "capital-increase") {
                    this.oldDisclaimer = true;
                } else {
                    this.oldDisclaimer = false;
                }
            }
        );
    }

    ngOnInit() {
        this.titleService.setTitle('Disclaimer');
        this.route.data.subscribe(data => {
            this.lingua = data['lang'];
            this.route.url.subscribe(() => {
                const url = this.location.path().split('/');
                this.pageName = url.pop();
                this.getOtherLangs();
            });
        });
    }

    accepted() {
        this.disclaimerAccepted.emit(true);
    }

    getOtherLangs() {
        this.multilingueService.search = new Search<Multilingua>(Multilingua);
        if (this.lingua === 'IT') {
            this.multilingueService.search._.it = this.pageName;
        } else if (this.lingua === 'EN') {
            this.multilingueService.search._.eng = this.pageName;
        }
        this.multilingueService.getList().subscribe(link => {
            // console.log('link trovato: ' + link);
            const lingue = [];
            if (link.length > 0) {
                if (this.lingua === 'EN' && link[0].it) {
                    lingue.push('IT');
                }
                if (this.lingua === 'IT' && link[0].eng) {
                    lingue.push('EN');
                }
            }
            this.menuService.add(lingue);
        });

    }

}
